<template>
  <a-modal
    :title="dialogTitle"
    :visible="visible"
    :mask-closable="false"
    :width="450"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk('form')"
  >
    <a-form-model
      ref="form"
      :model="form"
      label-align="right"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      :rules="validateRules"
    >
      <a-form-model-item
        label="产品类型:"
        prop="productTypeName"
      >
        <a-input
          v-model="form.productTypeName"
          placeholder="请填写产品类型"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item
        label="补贴方式:"
        prop="subsidyTypeId"
      >
        <a-select
          v-model="form.subsidyTypeId"
          placeholder="请选择补贴方式"
          allow-clear
        >
          <a-select-option
            v-for="item in subsidyTypes"
            :key="item.subsidyTypeId"
          >
            {{ item.subsidyTypeName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateProductType, addProductType } from '@/api/productManage.js'
import moment from 'moment'
import { deepClone } from '@/utils/utils.js'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    subsidyTypes: {
      type: Array,
      default: null
    },
    initData: {
      type: Object,
      default: null
    },
    dialogTitle: {
      type: String,
      default: null
    },
    productTypetions: {
      type: Array,
      default: null
    },
    actionType: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      form: {
        productTypeName: undefined,
        subsidyTypeId: undefined
      },
      validateRules: {
        productTypeName: [{ required: true, message: '请输入产品类型' }],
        subsidyTypeId: [{ required: true, message: '请输入补贴方式' }]
      },
      baseTemp: [],
      monthFormat: 'YYYY/MM'
    }
  },
  watch: {
    initData: {
      deep: true,
      handler: function (data) {
        // data.date =
        //    data.collectionDate
        //      ? moment(data.date).format('YYYY-MM')
        //      : null
        this.form = this.deepClone(data)
      }
    }
  },
  methods: {
    moment,
    deepClone,
    handleCancel () {
      this.$refs.form.resetFields()
      this.$emit('cancel')
    },
    handleOk () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.actionType === '0') {
            await updateProductType(
              {
                ...this.form
              }
            ).then(() => {
              this.$message.success('提交成功!')
              this.$emit('ok')
            })
          } else {
            await addProductType({
              ...this.form
            }
            ).then(() => {
              this.$message.success('提交成功!')
              this.$emit('ok')
            })
          }
        }
      })
    }
  }
}
</script>
